<span class="example-pizza-party">
    {{data.Message | translate}}
  </span>